const MediaplannerGroupEndpoints = {
  endpoints: {
    listPosts: "groups/content/listposts/",
    listCommentsOnPost: "groups/content/listcomments/",
    deletePostFromGroup: "groups/content/deletefromgroup/",
    copyPostFromGroup: "groups/content/copypost/",
    sharePost: "groups/content/share/",
    comment: "groups/content/comment",
    edit: "groups/content/editcomment",
    delete: "groups/content/deletecomment/",
    getAllImagesForPost: "groups/content/showpostfiles/",
    getImageBinary: "groups/content/getFileBinary/",
    /**
     * + groupId/postId. GET: files of a post shared in the group (member access).
     * POST: add a file to the shared post, same body as Documents.addToPost
     * ({ upload_id | file_string, file_name, original_name, name? }); the file
     * is stored in the group's file folder, not in the uploader's own files.
     * Author or group admin only.
     */
    postFiles: "groups/content/postfiles/",
    createdDashboard: "groups/content/createddashboard",
    scheduledDashboard: "groups/content/scheduleddashboard",
    createGroupPost: "groups/content/creategrouppost/",
    getGroupSchedules: "groups/content/getschedules/",
    removeAdmin: "groups/content/removeadmin/",
    deletePost: "groups/content/deletepost/",
    publishedPosts: "groups/content/publishedposts/",
    /** GET + groupId: every schedule planned on a member's account, with approval state */
    approvals: "groups/content/approvals/",
    notes: {
      list:   "groups/note/list/",
      new:    "groups/note/new/",
      edit:   "groups/note/edit/",
      delete: "groups/note/delete/",
    },
    pillars: {
      list:   "groups/pillars/list/",
      new:    "groups/pillars/new/",
      copy:   "groups/pillars/copy/",
      delete: "groups/pillars/delete/",
    },
    /** default title CSS for images in posts shared into the group (GET + PUT) */
    overlay: "groups/overlay/",
    /** + groupId: logo of a user-created group. GET bytes (204 when none), PUT { file_string, file_name }, DELETE */
    logo: "groups/logo/",
    /**
     * The group's file folder: files owned by the group, same bodies as the
     * personal file manager (Documents/endpoints), plus the group id. Every
     * member reads and uploads; delete is for the uploader or an admin
     * (`can_delete` on each list row).
     */
    documents: {
      /** GET + groupId: rows of { document, uploader, can_delete } */
      list: "groups/documents/list/",
      /** POST + groupId: { file_string, file_name, name?, folder_path? } */
      new: "groups/documents/new/",
      /** DELETE + groupId/fileId */
      delete: "groups/documents/delete/",
      /** GET + groupId/fileId: the bytes (204 when missing) */
      show: "groups/documents/preview/",
      /** GET + groupId/fileId: a copy in the caller's own file manager */
      copy: "groups/documents/copy/",
      /** PUT + groupId/fileId: { path } (empty = root) */
      moveToFolder: "groups/documents/folder/",
      /** GET / POST { path } / DELETE ?path= , + groupId */
      folders: "groups/documents/folders/",
      /** PUT + groupId + "/rename": { from, to } */
      folderRename: "groups/documents/folders/",
    },
  },
};

export default MediaplannerGroupEndpoints;
